const Common = {
  colors: {
    mainColor: "#6667AB",
    secondaryColor: "#8C8EB8",
  },
  fontSize: {
    title: "2.4rem",
    fs20: "2.0rem",
    fs16: "1.6rem",
    fs13: "1.3rem",
  },
};

export default Common;
